export class FuseAnimationCurves
{
    static readonly standard = 'cubic-bezier(0.4, 0.0, 0.2, 1)';
    static readonly deceleration = 'cubic-bezier(0.0, 0.0, 0.2, 1)';
    static readonly acceleration = 'cubic-bezier(0.4, 0.0, 1, 1)';
    static readonly sharp = 'cubic-bezier(0.4, 0.0, 0.6, 1)';
}

export class FuseAnimationDurations
{
    static readonly complex = '375ms';
    static readonly entering = '225ms';
    static readonly exiting = '195ms';
}
